import {ResolveFn} from '@angular/router';
import {ApiService} from "@app/_services/api.service";
import {inject} from "@angular/core";
import {forkJoin, map} from "rxjs";

export const ediFileSummaryResolver: ResolveFn<any> = () => {
    const apiService = inject(ApiService);
    return forkJoin({
        customers: apiService.getCustomers(),
        tradingPartnerNames: apiService.getEdiPartnerMappings().pipe(
            map(mappings => [...new Set(mappings.map(m => m.name))])
        )
    });
};
